export default __webpack_public_path__ + "static/media/reports-icon.8afa2f70.svg";